/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.RecurringRemarkFilter = (function() {

    /**
     * Namespace RecurringRemarkFilter.
     * @exports RecurringRemarkFilter
     * @namespace
     */
    var RecurringRemarkFilter = {};

    RecurringRemarkFilter.RecurringRemarkFilterModel = (function() {

        /**
         * Properties of a RecurringRemarkFilterModel.
         * @memberof RecurringRemarkFilter
         * @interface IRecurringRemarkFilterModel
         * @property {string|null} [remark] RecurringRemarkFilterModel remark
         * @property {number|null} [active] RecurringRemarkFilterModel active
         * @property {string|null} [sortColumn] RecurringRemarkFilterModel sortColumn
         * @property {string|null} [sortOrder] RecurringRemarkFilterModel sortOrder
         * @property {number|null} [pageIndex] RecurringRemarkFilterModel pageIndex
         * @property {number|null} [pageSize] RecurringRemarkFilterModel pageSize
         */

        /**
         * Constructs a new RecurringRemarkFilterModel.
         * @memberof RecurringRemarkFilter
         * @classdesc Represents a RecurringRemarkFilterModel.
         * @implements IRecurringRemarkFilterModel
         * @constructor
         * @param {RecurringRemarkFilter.IRecurringRemarkFilterModel=} [p] Properties to set
         */
        function RecurringRemarkFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * RecurringRemarkFilterModel remark.
         * @member {string|null|undefined} remark
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        RecurringRemarkFilterModel.prototype.remark = null;

        /**
         * RecurringRemarkFilterModel active.
         * @member {number|null|undefined} active
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        RecurringRemarkFilterModel.prototype.active = null;

        /**
         * RecurringRemarkFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        RecurringRemarkFilterModel.prototype.sortColumn = null;

        /**
         * RecurringRemarkFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        RecurringRemarkFilterModel.prototype.sortOrder = null;

        /**
         * RecurringRemarkFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        RecurringRemarkFilterModel.prototype.pageIndex = null;

        /**
         * RecurringRemarkFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        RecurringRemarkFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * RecurringRemarkFilterModel _remark.
         * @member {"remark"|undefined} _remark
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        Object.defineProperty(RecurringRemarkFilterModel.prototype, "_remark", {
            get: $util.oneOfGetter($oneOfFields = ["remark"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * RecurringRemarkFilterModel _active.
         * @member {"active"|undefined} _active
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        Object.defineProperty(RecurringRemarkFilterModel.prototype, "_active", {
            get: $util.oneOfGetter($oneOfFields = ["active"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * RecurringRemarkFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        Object.defineProperty(RecurringRemarkFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * RecurringRemarkFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        Object.defineProperty(RecurringRemarkFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * RecurringRemarkFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        Object.defineProperty(RecurringRemarkFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * RecurringRemarkFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @instance
         */
        Object.defineProperty(RecurringRemarkFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified RecurringRemarkFilterModel message. Does not implicitly {@link RecurringRemarkFilter.RecurringRemarkFilterModel.verify|verify} messages.
         * @function encode
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @static
         * @param {RecurringRemarkFilter.IRecurringRemarkFilterModel} m RecurringRemarkFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RecurringRemarkFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.remark != null && Object.hasOwnProperty.call(m, "remark"))
                w.uint32(10).string(m.remark);
            if (m.active != null && Object.hasOwnProperty.call(m, "active"))
                w.uint32(16).int32(m.active);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(26).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(34).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(40).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(48).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified RecurringRemarkFilterModel message, length delimited. Does not implicitly {@link RecurringRemarkFilter.RecurringRemarkFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @static
         * @param {RecurringRemarkFilter.IRecurringRemarkFilterModel} message RecurringRemarkFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RecurringRemarkFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RecurringRemarkFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {RecurringRemarkFilter.RecurringRemarkFilterModel} RecurringRemarkFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RecurringRemarkFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.RecurringRemarkFilter.RecurringRemarkFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.remark = r.string();
                    break;
                case 2:
                    m.active = r.int32();
                    break;
                case 3:
                    m.sortColumn = r.string();
                    break;
                case 4:
                    m.sortOrder = r.string();
                    break;
                case 5:
                    m.pageIndex = r.int32();
                    break;
                case 6:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a RecurringRemarkFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof RecurringRemarkFilter.RecurringRemarkFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {RecurringRemarkFilter.RecurringRemarkFilterModel} RecurringRemarkFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RecurringRemarkFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return RecurringRemarkFilterModel;
    })();

    return RecurringRemarkFilter;
})();

module.exports = $root;
